export default __webpack_public_path__ + "static/media/opredelenie-pobeditelya.73feb6ef.pdf";